import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { SpecializationConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { SpecializationService } from './api/specialization.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class SpecializationApiModule {
    public static forRoot(configurationFactory: () => SpecializationConfiguration): ModuleWithProviders<SpecializationApiModule> {
        return {
            ngModule: SpecializationApiModule,
            providers: [ { provide: SpecializationConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: SpecializationApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('SpecializationApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
